module.exports = __webpack_public_path__ + "static/front-5a444cadc7c1cf89c3db9e0ed8907758.jpg";